import gql from 'graphql-tag'

export const GET_CUSTOMER_NAVIGATION = gql`
  query GetCustomerNavigation {
    customerNavigation {
      customerName
      landingPageUrl
      parentCustomerName
      parentCustomerProductCategoryLinks {
        displayName
        url
      }
      productCategoryLinks {
        displayName
        url
      }
      documentsAndLinks {
        displayName
        url
      }
      contacts {
        name
        title
        phone
        email
      }
      logo {
        url
      }
    }
  }
`
